"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TenantSwitch = exports._TenantSwitch = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _classnames = _interopRequireDefault(require("classnames"));

var _skybaseComponents = require("skybase-ui/skybase-components");

var _shapes = require("skybase-ui/skybase-core/shapes");

var _oauth = require("../../oauth");

var _utils = require("../../tenants/utils");

var _constants = require("../constants");

var _constants2 = require("../../tenants/constants");

var _shapes2 = require("./shapes");

var _utils2 = require("../../utils");

var _usersI18n = require("../../users/users-i18n");

var _auth = require("../../auth");

var _oauthPermissions = require("../../oauth-permissions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _TenantSwitch = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(_TenantSwitch, _PureComponent);

  var _super = _createSuper(_TenantSwitch);

  function _TenantSwitch() {
    var _this;

    (0, _classCallCheck2.default)(this, _TenantSwitch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOnBackClick", function () {
      var onBackClick = _this.props.onBackClick;

      if (onBackClick) {
        onBackClick();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOnChange", function (tenantId) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          tenant = _this$props.tenant;

      if (onClick) {
        onClick();
      } // Reset the token and redirect to the authorize URL to request a new token with a different tenant.


      if (tenant !== tenantId) {
        // Clean up the local storage.
        _oauth.OAuth.oAuthService.invalidateSession();

        var url = new URL(_oauth.OAuth.oAuthService.getAuthorizeUrl());
        url.searchParams.set('tenant', tenantId);
        window.location = url.href;
      }
    });
    return _this;
  }

  (0, _createClass2.default)(_TenantSwitch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          handleFetchAllTenants = _this$props2.handleFetchAllTenants,
          read = _this$props2.acl.read;

      if (read) {
        handleFetchAllTenants();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          _ = _this$props3.intl.formatMessage,
          tenant = _this$props3.tenant,
          allTenants = _this$props3.allTenants;
      var tenants = allTenants.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          iconClass: 'sbi-checkhook',
          className: (0, _classnames.default)('checkhook-icon', {
            hidden: item.value !== tenant
          })
        });
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-user-buttons tenant-switch"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "fl-row fl-justify-sb fl-align-items-center m-b-5"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "back sbi-arrow-right",
        onClick: this.handleOnBackClick
      }), /*#__PURE__*/_react.default.createElement("h3", null, _(_usersI18n.messages.switchTenant)), /*#__PURE__*/_react.default.createElement("span", null)), /*#__PURE__*/_react.default.createElement("div", {
        className: "m-t-5"
      }, /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbMultiselect, {
        selected: tenant,
        maxHeight: 180,
        minHeight: 120,
        items: tenants,
        multiselect: true,
        onChange: this.handleOnChange,
        mode: "radio",
        placeholder: _(_usersI18n.messages.searchTenants)
      })));
    }
  }]);
  return _TenantSwitch;
}(_react.PureComponent);

exports._TenantSwitch = _TenantSwitch;
(0, _defineProperty2.default)(_TenantSwitch, "propTypes", {
  intl: _shapes.intlShape.isRequired,
  // eslint-disable-line
  acl: _auth.aclShape.isRequired,
  onBackClick: _propTypes.default.func,
  allTenants: _propTypes.default.arrayOf(_shapes2.listShape).isRequired,
  tenant: _propTypes.default.string.isRequired,
  handleFetchAllTenants: _propTypes.default.func.isRequired,
  onClick: _propTypes.default.func
});
(0, _defineProperty2.default)(_TenantSwitch, "defaultProps", {
  onBackClick: null,
  onClick: null
});

var mapStateToProps = function mapStateToProps(state) {
  var tenant = (0, _utils2.getOAuthState)(state)[_constants.AUTH_STATE_KEY_NAME].tenant;

  var allTenants = (0, _utils2.getOAuthState)(state)[_constants2.TENANTS_STATE_KEY_NAME].all;

  return {
    tenant: tenant,
    allTenants: allTenants
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleFetchAllTenants: function handleFetchAllTenants() {
      return dispatch((0, _utils.fetchAllTenants)());
    }
  };
};

var withAclComponent = (0, _auth.withAcl)(_TenantSwitch, {
  readPermissions: [_oauthPermissions.oAuthPermissions.kiconnectTenantsAdminister]
});
var TenantSwitch = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(withAclComponent));
exports.TenantSwitch = TenantSwitch;
//# sourceMappingURL=tenant-switch.js.map